import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_manufacturing_output_locations_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouse_ids?: number[], full_text_search?: string, project_id?: number, location_ids?: number[] }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, ManufacturingLineFlag?: boolean, Name?: string, TypeId?: number, WarehouseId?: number, LocationContainersAssignedProjectsLookupLocationContainer?: { ProjectId?: number }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_output_locations_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouse_ids?: number[], full_text_search?: string, project_id?: number, location_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, ManufacturingLineFlag?: boolean, Name?: string, TypeId?: number, WarehouseId?: number, LocationContainersAssignedProjectsLookupLocationContainer?: { ProjectId?: number }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_output_locations_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouse_ids?: number[], full_text_search?: string, project_id?: number, location_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, ManufacturingLineFlag?: boolean, Name?: string, TypeId?: number, WarehouseId?: number, LocationContainersAssignedProjectsLookupLocationContainer?: { ProjectId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_output_locations_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouse_ids?: number[], full_text_search?: string, project_id?: number, location_ids?: number[]    }) {
      return false;
    }
}
